import React from "react";
import styled, { keyframes } from "styled-components";
import colors from "../../../constants/colors";

const float = keyframes`
  0%, 100% { transform: translateY(0px) scale(1); }
  50% { transform: translateY(-8px) scale(1.02); }
`;

const pulse = keyframes`
  0%, 100% { opacity: 0.6; }
  50% { opacity: 0.3; }
`;

const EmptyUsersContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const UsersGroup = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
  animation: ${float} 3s ease-in-out infinite;
  direction: rtl;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const UserIcon = styled.div<{ $delay: number; $size: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  opacity: 0.6;
  animation: ${pulse} 2s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const UserHead = styled.div<{ $size: number }>`
  width: ${({ $size }) => $size * 0.4}px;
  height: ${({ $size }) => $size * 0.4}px;
  border-radius: 50%;
  background: linear-gradient(135deg, ${colors.PURPLE_LIGHT} 0%, ${colors.PURPLE} 100%);
  border: 2px solid ${colors.PURPLE};
`;

const UserBody = styled.div<{ $size: number }>`
  width: ${({ $size }) => $size * 0.6}px;
  height: ${({ $size }) => $size * 0.5}px;
  border-radius: 50% 50% 0 0 / 60% 60% 0 0;
  background: ${colors.GRADIENT_PURPLE};
  border: 2px solid ${colors.PURPLE};
  border-bottom: none;
`;

const EmptyUsers: React.FC = () => {
  return (
    <EmptyUsersContainer>
      <UsersGroup>
        <UserIcon $delay={0} $size={50}>
          <UserHead $size={50} />
          <UserBody $size={50} />
        </UserIcon>
        <UserIcon $delay={0.3} $size={65}>
          <UserHead $size={65} />
          <UserBody $size={65} />
        </UserIcon>
        <UserIcon $delay={0.6} $size={55}>
          <UserHead $size={55} />
          <UserBody $size={55} />
        </UserIcon>
      </UsersGroup>
    </EmptyUsersContainer>
  );
};

export default EmptyUsers;
